import React, { useState, useEffect } from "react";
import Select from "react-select";
import {Search} from 'lucide-react';
import classes from "./PendingAccount.module.css"
import plus from "../../../Assets/plus.svg"
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form, Row, Col, Container, Table } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import axios from 'axios';
import Swal from 'sweetalert2';
import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
import RotatingLogo from '../../../Assets/rotating-logo.png';
import { FaTrash, FaPlus } from "react-icons/fa";  
import download from "../../../Assets/download1.svg"
import { MdAdd } from "react-icons/md";
import { BASE_URL } from "../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";




const loans = [
  { sn: 1, code: "651211", description: "LOAN", reportTo: "IMPAIRMENT OF RECEIVABLES" },
  { sn: 2, code: "012987", description: "CAR LOAN", reportTo: "CAR ADVANCES" },
  { sn: 3, code: "981236", description: "RENT LOAN", reportTo: "RENT ADVANCES" },
  { sn: 4, code: "23412", description: "EMERGENCY LOAN", reportTo: "RENT ADVANCES" },
  { sn: 5, code: "12345", description: "STAFF LOAN", reportTo: "LOAN TO STAFF" },
  { sn: 6, code: "456321", description: "STUDENT LOAN", reportTo: "LOAN TO PARISH/AREA" },
  { sn: 7, code: "789043", description: "SALARY LOAN", reportTo: "AREA & PROVINCE REMITABLES" },
  { sn: 8, code: "00256", description: "SALARY LOAN", reportTo: "AREA & PROVINCE REMITABLES" },
  { sn: 9, code: "09383", description: "School Office", reportTo: "BANK CHARGES" },
  { sn: 10, code: "53672", description: "Emergency Stuff", reportTo: "SUBSCRIPTION & DONATIONS" },
];



const PendingApproval = () => {
  const token = localStorage.getItem("userToken");
    const [selectedOption, setSelectedOption] = useState(null);
    const [searchTerm,setSearchTerm] = useState("");
    const [show, setShow] = useState(false);
    const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [suppliers, setSuppliers] = useState([]);
  const [show1, setShow1] = useState(false);
  const [uploadShow, setUploadShow] = useState(false);
  const [file, setFile] = useState(null);
  const [bearer, setBearer] = useState('');
  const [uploadLoading, setUploadLoading] = useState(false);
  const [bankName, setBankName] = useState('');
  const [bankName1, setBankName1] = useState('');
  const [accName, setAccName] = useState('');
  const [accName1, setAccName1] = useState('');
  const [accNo, setAccNo] = useState('');
  const [accNo1, setAccNo1] = useState('');
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState();
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState();
  const [address, setAddress] = useState([]);
  const [address1, setAddress1] = useState();
  const [phone, setPhone] = useState();
  const [phoneNo, setPhoneNo] = useState("");
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);
  // const [totalEntries, setTotalEntries] = useState("");
  const [tableData, setTableData] = useState([]);
  const [tableData2, setTableData2] = useState([]);
  const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);

  

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');

      if (value !== null) {
        setBearer(value);
      }
      if (value1 !== null) {
        setUser(value1);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };

  

  const handleClose1 = () => setShow1(false);

const handleShow1 = (item) => {
  setSuppliers(item)
  setFullName1(item.name || "");
  setEmail1(item.email || "");
  setAddress1(item.address || "");
  setPhoneNo(item.phone_number || "");
  setShow1(true);
};

//   setBenLoading(true);
//   try {
//     const response = await axios.get(`${BASE_URL}/beneficiary`, { headers });
//     const results = response.data?.data;
//     const resultx = response.data?.data?.total;
//     // setTotalEntries(resultx);
//     setTableData(results);
//     const total = response.data?.data?.last_page || 1;
//     // setTotalPages(total);

//   } catch (error) {
//     if (error.response && error.response.status === 401) {
//       navigate('/login');
//     } else {
//       let errorMessage = 'An error occurred. Please try again.';
//       if (error.response && error.response.data && error.response.data.message) {
//         if (typeof error.response.data.message === 'string') {
//           errorMessage = error.response.data.message;
//         } else if (Array.isArray(error.response.data.message)) {
//           errorMessage = error.response.data.message.join('; ');
//         } else if (typeof error.response.data.message === 'object') {
//           console.log(errorMessage);
//           setError(errorMessage)
//         }
//       }
//       setTableData([]);
//     }
//   } finally {
//     setBenLoading(false);
//   }

// };

// useEffect(() => {
//   if (bearer) {
//     FetchSuppliers();
//   }
// }, [bearer, currentPage]);


const handleShow = () => setShow(true);
const handleClose = () => setShow(false);

    // const handleChange = (option) => {
    //         setSelectedOption(option);
    //         console.log("Selected:", option);
    //     };

  const [rows, setRows] = useState([{ bankName: "", accName: "", accNo: "" }]);

  const addRow = () =>
    setRows([...rows, { bankName: "", accName: "", accNo: "" }]);

  const deleteRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

  const handleChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

const handleUploadShow = () => setUploadShow(true);
const handleUploadClose = () => {
  setUploadShow(false);
  setFile(null);
};

const handleFileChange = (event) => {
  const file = event.target.files[0];
  setFile(file);
};


const updateBeneficiary = async () => {

  setUploadLoading(true);
  try {
    const bankAccounts = rows.map(item => item.accNo);
    const accountNames = rows.map(item => item.accName);
    const bankNames = rows.map(item => item.bankName);

    const response = await axios.post(`${BASE_URL}/beneficiaryaccounts/update`,
      {
        name: fullName1,
        email: email1,
        phone_number: phoneNo,
        address: address1,
        bank_account: bankAccounts,
        account_name: accountNames,
        bank_name: bankNames,
        id: suppliers.id
       
      },
      { headers }
    );
    handleClose1();
    //FetchSuppliers();
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    })
    // .then(() => {
    //   window.location.reload();
    // });
    console.log(response.data.message)
    setUploadLoading(false);
} catch (error) {
  let errorMessage = error.response?.data?.message;
  // let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            console.log("error", errorMessage);
          }
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: errorMessage,
          });
      }
  } finally {
    setUploadLoading(false);
  }
};

const uploadExcelHandler = async () => {
  if (!file) {
    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: 'Please select a file to upload',
    });
    return;
  }

    // Confirmation alert before upload
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to upload this file?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, upload it!",
      cancelButtonText: "No, cancel",
    });
  
    if (!result.isConfirmed) {
      handleUploadClose(); 
      return; 
    }

  setUploadLoading(true);
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(
      `${BASE_URL}/beneficiary/upload`, 
      formData, 
      { headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${bearer}`
        } });

    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message || 'File uploaded successfully',
    });
    window.location.reload();

    handleUploadClose();
    setFile("");
  } catch (error) {
    let errorMessage;

    if (error.response && error.response.data) {
      errorMessage = typeof error.response.data.message === 'object'
        ? JSON.stringify(error.response.data.message)
        : error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    } else {
      errorMessage = 'An unexpected error occurred while uploading the file';
    }

    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: errorMessage,
    });
    console.log(error);
  } finally {
    setUploadLoading(false);
  }
};

const createBeneficiary = async () => {
  setLoading(true);
  try {
    const response = await axios.post(`${BASE_URL}/beneficiary/add`,
      {
        name: fullName,
        email: email,
        phone_number: phone,
        address: address,
        bank_name: bankName,
        account_name: accName,
        account_number: accNo
      },
      { headers }
    );
    console.log(response.data.message);
    setFullName('');
    setEmail('');
    setPhone('');
    setAddress('');
    setBankName('');
    setAccName('');
    setAccNo('');
    //FetchSuppliers();
    handleClose();
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });
    console.log(response.data.message);

  } catch (error) {
    let errorMessage;

    // Attempt to extract the error message
    if (error.response && error.response.data) {
      // If message is an object, attempt to stringify it
      if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      } else {
        errorMessage = error.response.data.message;
      }
    } else if (error.message) {
      errorMessage = error.message;
    } else {
      errorMessage = "An unexpected error occurred";
    }

    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: errorMessage,
    });
    console.log(error);
  } finally {
    setLoading(false);
  }
};

 //delete function
 const handleTrashClick = async (id) => {
  const confirmed = await Swal.fire({
    title: 'Are you sure?',
    text: 'You are about to delete this member.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, cancel',
  });

  if (!confirmed.isConfirmed) {
    return; // User canceled, do nothing
  }
  setUploadLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/beneficiary/delete?id=${id}`, { headers });
    //FetchSuppliers();
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });
   
    setUploadLoading(false);
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      }
      // toast.error(errorMessage)
      console.log(errorMessage);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: errorMessage,
      });
    }
  }
  finally {
    setUploadLoading(false); // always stop uploading, success or fail
  }
};

const fetchData = async () => {
  setIsLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/account/all-pending`, { headers });
    const subCat = response.data?.data;
    setTableData2(subCat);
  } catch (error) {
    if (error.response && error.response.status === 401) {
      // Redirect to login page if unauthorized
      navigate('/login');
    } else {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setTableData2([]);
    }
  } finally {
    setIsLoading(false);
  }
};

useEffect(() => {
  if (token) {
    // fetchData();
    fetchData();
  }
}, [token]);


const filteredData = tableData2.filter(item => item.gl_name.toLowerCase().includes(searchTerm.toLowerCase()));
const totalEntries = filteredData.length;
const startIndexx = (currentPage - 1) * entriesPerPage + 1;
const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);
const displayedData = filteredData.slice(startIndexx - 1, endIndexx);

const totalPages = Math.ceil(filteredData.length / entriesPerPage);
const formattedTotalEntries = totalEntries.toLocaleString();

// const startIndexx = (currentPage - 1) * entriesPerPage + 1;
// const filteredData = tableData.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase()));
// const totalEntries = filteredData.length;
// const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);
// const displayedData = filteredData.slice(startIndexx - 1, endIndexx);

const handlePrevPage = () => {
  setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
};

const handleNextPage = () => {
  setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
};

function formatDate(dateString) {
  const date = new Date(dateString);
  const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
  return formattedDate;
}

function padZero(num) {
  return num < 10 ? `0${num}` : num;
}





        
  return (
    <div >
        <HeaderNav />
      
    
<Modal show={show1} onHide={handleClose1} size="lg" animation={false}>
  <Modal.Header closeButton>
    <Modal.Title>Update Suppliers</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group className="mb-3">
      <Row>
        <Col>
        <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Name</Form.Label>
        <Form.Control
          type="text"
          placeholder="Name"
          value={fullName1}
          onChange={(e) => setFullName1(e.target.value)}
        />
        </Col>

        <Col>
        <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Email</Form.Label>
        <Form.Control
          type="text"
          placeholder="Email"
          value={email1}
          onChange={(e) => setEmail1(e.target.value)}
        />
        </Col>
      </Row>

      <Row>
        <Col>
        <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Phone Number</Form.Label>
        <Form.Control
          type="text"
          placeholder="Phone Number"
          value={phoneNo}
          onChange={(e) => setPhoneNo(e.target.value)}
        />
        </Col>

        <Col>
        <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Address</Form.Label>
      <Form.Control
          type="text"
          placeholder="Phone Number"
          value={address1}
          onChange={(e) => setAddress1(e.target.value)}
        />
        </Col>
      </Row>
        
      </Form.Group>

      {/* <div style={{display: "flex", gap: 30, alignItems: "center", justifyContent: "center" }}>
      <Col xs={10}>
        <h5 style={{ marginTop: "0px", textAlign: "center" }}>Add Bank Accounts</h5>
        </Col>

        <Col xs={2}>
        <Button style={{display: "flex", flexDirection: "column", alignItems: "flex-end" , justifyContent: "flex-end", textAlign: "right"}} variant="primary" onClick={addRow}>
          
          <FaPlus /> 
        </Button>
        </Col>
      </div> */}

      <Form.Group>
      <Container fluid style={{marginTop: "40px"}} className={classes.wrapper}>
      <h6 className={classes.headerText} style={{textAlign: "left"}}>Add Bank Accounts</h6>

      <div className="table-responsive">
      <table className={classes.customtable}>
        <thead>
          <tr>
            <th>Bank Name</th>
            <th>Account Name</th>
            <th>Account Number</th>
            <th style={{backgroundColor: "unset"}} className="text-center">
              <button style={{backgroundColor: "unset"}} className={classes.plusbtn} onClick={addRow}>
              <FaPlus
              size={12}
              color="white"
              style={{ cursor: "pointer" }}
            />
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              <td>
                <Form.Control
                  type="text"
                  value={row.bankName}
                  onChange={(e) =>
                    handleChange(index, "bankName", e.target.value)
                  }
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={row.accName}
                  onChange={(e) =>
                    handleChange(index, "accName", e.target.value)
                  }
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={row.accNo}
                  onChange={(e) =>
                    handleChange(index, "accNo", e.target.value)
                  }
                />
              </td>
              <td className="text-center">
                <button style={{backgroundColor: "unset"}} className={classes.btntrash} onClick={() => deleteRow(index)}>
                <img src={DeleteIcon}/>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </Container>
      </Form.Group>
 
    </Form>
  </Modal.Body>
  <Modal.Footer style={{marginRight: "14px"}}>
    <Button variant="danger" onClick={handleClose1}>
      Go back
    </Button>
    <Button className={classes.customButton} onClick={updateBeneficiary}>
     Update Benficiary
    </Button>

  </Modal.Footer>
</Modal>

<Modal show={uploadShow} onHide={handleUploadClose} animation={false}>
              <Modal.Header closeButton>
                <Modal.Title>Upload Excel File</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{padding: 0}}>
                <Form style={{ marginTop: 5 }}>
               
                  <Form.Group style={{padding: 10,}}>
                  {/* <button  className={classes.customButton1} >
                  <a href="https://account-api.patna.ng/api/v1/download_suppliers_template" download>
                  <img src={download} alt="download" /> Download Template
                    </a>
                </button> */}
                </Form.Group>
                  {/* <hr className={classes.downline} /> */}


                  <Form.Group style={{padding: 10}} className="mb-3" controlId="exampleForm.ControlInput2">
                    <Form.Label>Select Excel File</Form.Label>
                    <Form.Control
                      type="file"
                      accept=".xlsx, .xls"
                      onChange={handleFileChange}
                    />
                    <div style={{ marginTop: 10 }} />
                  </Form.Group>

                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="danger" onClick={handleUploadClose}>
                  Go back
                </Button>
                <Button  className={classes.customButton}  onClick={uploadExcelHandler}>
                  Upload File
                </Button>
              
              </Modal.Footer>
            </Modal>
            {uploadLoading && (
                <div className={classes.overlay}>
                  <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
                </div>
                )}

            <Modal show={show} onHide={handleClose} animation={false}>
          <Modal.Header closeButton>
            <Modal.Title>Add New Supplier/Contractor</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form style={{ marginTop: 20 }}>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Full Name"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
                <div style={{ marginTop: 10 }} />
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <div style={{ marginTop: 10 }} />
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter Phone Number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
                <div style={{ marginTop: 10 }} />
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
                <div style={{ marginTop: 10 }} />
                <Form.Label>Bank Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Supplier's Bank Name"
                  value={bankName}
                  onChange={(e) => setBankName(e.target.value)}
                />
                <div style={{ marginTop: 10 }} />
                <Form.Label>Account Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Supplier's Account Name"
                  value={accName}
                  onChange={(e) => setAccName(e.target.value)}
                />
                <div style={{ marginTop: 10 }} />
                <Form.Label>Account Number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Supplier's Account Number"
                  value={accNo}
                  onChange={(e) => setAccNo(e.target.value)}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={handleClose}>
              Go back
            </Button>
            <Button className={classes.customButton} onClick={createBeneficiary}>
              Create Beneficiary
            </Button>
          </Modal.Footer>
        </Modal>
        {loading && (
                <div className={classes.overlay}>
                  <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
                </div>
                )}


        <div className={classes.topContainer}>
          <div className={classes.topNavBars}>
            <Button className={classes.buttonsNav}>Remitances</Button>
            <Button className={classes.buttonsNav}>Petty Cash</Button>
            <Button className={classes.buttonsNav}>Accounting</Button>
            <Button className={classes.buttonsNav}>Customer's Leger</Button>
          </div>
          <div style={{marginBottom: "20px"}}>
            <h3 className={classes.topText}>Account Approval</h3>
            <p className={classes.prgText}>Approve and Disapprove Account</p>
            {/* <div className={classes.subContainer}>
               
                           
                            <div style={{marginLeft: "6px", display: "flex", gap: "20px"}}>
                            <button className={classes.loanBtn} 
               
                            onClick={handleShow}
                            >
                              <img src={plus} alt="plus" /> 
                              Add New
                            </button>

                            <button className={classes.loanBtn} 
                          onClick={handleUploadShow}
                          >
                            Upload Excel
                          </button>

                            <button  className={classes.customButton1} >
                            <a href="https://account-api.patna.ng/api/v1/download_suppliers_template" download>
                            <img src={download} alt="download" /> Download Template
                              </a>
                          </button> 
                          </div>

                          <div className={classes.statCount}>
                              <div className={classes.statConn}>
                              <p className={classes.txtHd}>Suppliers Accounts</p>
                              <p className={classes.txtHds}>{formattedTotalEntries}</p>
                              </div>
                            </div>

                         <div className={classes.searchInputWrapper}>
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className={classes.searchInput}
                                    placeholder="Search accounts..."
                                />
                                <Search className={classes.searchIcon} size={16} />
                            </div>

            </div> */}
            </div>
            
            <div className={classes.tableContainer}>
            
          <table className={classes.tableTable}>
  <thead className={classes.tableHeader}>
                             <tr>
                             <th>S/N</th>
                              <th style={{ width: "70px", whiteSpace: "wrap" }}>Account Code</th>
                              <th>Account Name</th>
                              <th style={{ width: "70px", whiteSpace: "wrap" }}>Account Type</th>
                              <th style={{ width: "70px", whiteSpace: "wrap" }}>Category</th>
                              <th style={{ width: "70px", whiteSpace: "wrap" }}>Sub Category</th>
                              <th style={{ width: "70px", whiteSpace: "wrap" }}>Created By</th>
                              <th style={{ width: "70px", whiteSpace: "wrap" }}>Created Date</th>
                              <th>Directions</th>
                            </tr>
  </thead>

  <tbody>
  {isLoading ? (
    // 🟡 Show skeleton rows while loading
    Array(5).fill().map((_, idx) => (
      <tr key={idx}>
        {Array(9).fill().map((_, i) => (
          <td key={i}>
            <Skeleton height={20} style={{ marginBottom: 10 }} />
          </td>
        ))}
      </tr>
    ))
  ) : displayedData.length === 0 && tableData.length === 0 ? (
    // ⚪️ When not loading and no data — render null
    <tr>
      <td colSpan={9} style={{ textAlign: "center", padding: "20px", fontStyle: "italic", color: "#666" }}>
        No accounts found
      </td>
    </tr>
  ) : (
    // ✅ Render actual data rows
    <>
      {displayedData.map((item, index) => (
        <tr key={`display-${index}`}>
          <td style={{ width: 200 }}>{index + 1}</td>
          <td style={{ textAlign: "left", whiteSpace: "wrap", width: 300 }}>{item.gl_code}</td>
          <td style={{ textAlign: "left", whiteSpace: "wrap", width: 300 }}>{item.gl_name}</td>
          <td style={{ width: 60, whiteSpace: "wrap" }}>{item.class?.description}</td>
          <td style={{ width: 120, whiteSpace: "wrap" }}>{item.category?.description}</td>
          <td style={{ textAlign: "left", width: 200, whiteSpace: "wrap" }}>{item.subcategory?.description}</td>
          <td style={{ textAlign: "left", width: 200, whiteSpace: "wrap" }}>{item.created_by?.name}</td>
          <td style={{ textAlign: "left", width: 200, whiteSpace: "wrap" }}>{formatDate(item.created_at)}</td>
          <td style={{ textAlign: "left", width: 60, whiteSpace: "wrap" }}>{item.direction === "1" ? "DR" : "CR"}</td>
        </tr>
      ))}

      {tableData.map((item, index) => (
        <tr key={`table-${index}`}>
          <td style={{ width: 200 }}>{index + 1}</td>
          <td style={{ textAlign: "left", whiteSpace: "wrap", width: 300 }}>{item.gl_code}</td>
          <td style={{ textAlign: "left", whiteSpace: "wrap", width: 300 }}>{item.gl_name}</td>
          <td style={{ width: 60, whiteSpace: "wrap" }}>{item.class?.description}</td>
          <td style={{ width: 120, whiteSpace: "wrap" }}>{item.category?.description}</td>
          <td style={{ textAlign: "left", width: 200, whiteSpace: "wrap" }}>{item.subcategory?.description}</td>
          <td style={{ textAlign: "left", width: 200, whiteSpace: "wrap" }}>{item.created_by?.name}</td>
          <td style={{ textAlign: "left", width: 200, whiteSpace: "wrap" }}>{formatDate(item.created_at)}</td>
          <td style={{ textAlign: "left", width: 60, whiteSpace: "wrap" }}>{item.direction === "1" ? "DR" : "CR"}</td>
        </tr>
      ))}
    </>
  )}
</tbody>


</table>

{!benLoading && (
            <div className={classes.paginationStyle}>
              <div className={classes.footerSubOne}>
                <button onClick={handlePrevPage}
                  disabled={currentPage === 1} className={classes.btnFirst}>Prev</button>
                {[...Array(totalPages)].map((_, page) => {
                  // Show only 5 pages or less if available
                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                    return (
                      <span key={page + 1} className={classes.ftOne}>
                        <button
                          className={`${classes.pageNumber} ${currentPage === page + 1 ? classes.active : ""}`}
                          onClick={() => setCurrentPage(page + 1)}
                        >
                          {page + 1}
                        </button>
                      </span>
                    );
                  }
                })}


                <button className={classes.btnSec} onClick={handleNextPage}
                  disabled={currentPage === totalPages}>Next</button>
              </div>
              <p className={classes.displayPag}>Displaying {`Page ${currentPage} - ${totalPages} pages`} of {formattedTotalEntries} entries</p>
            </div>
          )}



            </div>
        </div>
    </div>
  )
}

export default PendingApproval